import { defineStore } from 'pinia';

export const useEventStore = defineStore('event', {
  state: () => ({
    isEventMode: false,
    eventId: null,
    eventData: null,
    theme: null,
    whiteLabel: false,
    customColor: null,
    bgImageURL: null,
    bgOpacity: 0.95,
  }),
  actions: {
    setEventMode(id, data = null) {
      this.isEventMode = true;
      this.eventId = id;
      this.eventData = data;
    },
    setTheme(theme) {
      this.theme = theme;
    },
    setWhiteLabel(v) {
      this.whiteLabel = !!v;
    },
    setCustomization({ customColor, bgImageURL, bgOpacity } = {}) {
      if (customColor !== undefined) this.customColor = customColor;
      if (bgImageURL !== undefined) this.bgImageURL = bgImageURL;
      if (bgOpacity !== undefined) this.bgOpacity = bgOpacity;
    },
    reset() {
      this.isEventMode = false;
      this.eventId = null;
      this.eventData = null;
      this.theme = null;
      this.whiteLabel = false;
      this.customColor = null;
      this.bgImageURL = null;
      this.bgOpacity = 0.95;
    }
  }
});
